/** Helpers for flexible API shapes (call-records + relations). */

export const getCallRecordId = (row) => row?.id ?? row?.uuid ?? '';

export const getLeadName = (row) =>
  row?.lead?.name ?? row?.lead_name ?? '—';

/** Comma-separated names of everyone assigned to the lead (API: lead.assignees[]). */
export const getLeadAssigneeNames = (row) => {
  const assignees = row?.lead?.assignees;
  if (!Array.isArray(assignees) || assignees.length === 0) return '—';
  const names = assignees
    .map((a) => a?.name ?? a?.username ?? '')
    .filter(Boolean);
  return names.length ? names.join(', ') : '—';
};

export const getCloserName = getLeadAssigneeNames;

export const getStatusLabel = (row) =>
  row?.status?.name ?? row?.status_name ?? row?.last_status?.name ?? '—';

/** All recordings attached to a call record (API: recordings[]). */
export const getRecordingsList = (row) => {
  const recs = row?.recordings;
  if (Array.isArray(recs) && recs.length) return recs;
  if (row?.recording) return [row.recording];
  if (Array.isArray(row?.media) && row.media.length) return row.media;
  return [];
};

/** First recording / attachment / media on the row */
export const getFirstRecording = (row) => {
  const list = getRecordingsList(row);
  return list[0] ?? null;
};

export const getRecordingUrl = (rec) => {
  if (!rec) return '';
  return (
    rec.url ??
    rec.path ??
    rec.full_url ??
    rec.original_url ??
    rec.file_url ??
    ''
  );
};

export const getRecordingDisplayName = (rec) => {
  if (!rec) return '—';
  const url = getRecordingUrl(rec);
  return rec.title ?? rec.name ?? rec.file_name ?? (url || 'Recording');
};

/** Extract entity id from a typical API envelope */
export const extractIdFromResponse = (payload) => {
  const d = payload?.data ?? payload;
  const inner = d?.data ?? d;
  return inner?.id ?? inner?.uuid ?? d?.id ?? d?.uuid ?? null;
};

/** After file upload — attachment / recording uuid */
export const extractRecordingUuidFromUpload = (payload) => {
  const d = payload?.data ?? payload;
  const inner = d?.data ?? d;
  return (
    inner?.uuid ??
    inner?.id ??
    d?.uuid ??
    d?.id ??
    inner?.attachment_id ??
    null
  );
};
